import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { useOrderEditContext } from '../OrderEditContext';

const PAGE_SIZE = 12;

const getQtyByVariantId = (lineItems) => {
  return (lineItems || []).reduce((accumulator, item) => {
    accumulator[item.product_id] = item.quantity ?? 0;
    return accumulator;
  }, {});
};

const useProductPickerPanel = () => {
  const {
    openProductPicker,
    setOpenProductPicker,
    filterProducts,
    setProductFilterValue,
    lineItems,
    addProduct,
    onLineQuantityChange,
  } = useOrderEditContext();

  const [page, setPage] = useState(1);

  const productGroups = useMemo(() => {
    const grouped = _.groupBy(filterProducts, (variant) => variant.product?.id);

    return Object.values(grouped).map((variants) => ({
      productId: variants[0].product?.id,
      productName: variants[0].product?.name ?? '(Không tên)',
      variants,
    }));
  }, [filterProducts]);

  const qtyByVariantId = useMemo(() => getQtyByVariantId(lineItems), [lineItems]);

  useEffect(() => {
    setPage(1);
  }, [productGroups.length]);

  const pagedGroups = productGroups.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const getCurrentQty = (variantId) => qtyByVariantId[variantId] ?? 0;

  return {
    openProductPicker,
    setOpenProductPicker,
    setProductFilterValue,
    qtyByVariantId,
    addProduct,
    onLineQuantityChange,
    page,
    setPage,
    pagedGroups,
    productGroups,
    getCurrentQty,
    pageSize: PAGE_SIZE,
  };
};

export default useProductPickerPanel;